<template>
  <div>
    <div class="tw-flex tw-flex-row tw-justify-between tw-px-4 tw-items-center tw-mb-4">
      <span class="tw-text-sm tw-font-semibold tw-text-secondary-500">
        {{ t('customer_management.titles.customer_list') }}
      </span>
      <button
        @click="createCustomer"
        class="tw-text-sm tw-font-semibold tw-text-primary-400 tw-underline hover:tw-text-primary-600 tw-transition-colors tw-duration-300"
      >
        {{ t('customer_management.actions.create_customer') }}
      </button>
    </div>
    <CustomersFancyTable />
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import CustomersFancyTable from './Table/CustomersFancyTable.vue';
import router from '@/router';
import { onMounted } from 'vue';
import { useBreadcrumbs } from '@/composables/useBreadcrumbs';
const { setBreadcrumbs } = useBreadcrumbs();
const { t } = useI18n();

const createCustomer = () => {
  router.push({ name: 'create-customer' });
};
onMounted(() => {
  // Set breadcrumbs for this specific page
  setBreadcrumbs([
    {
      labelKey: 'sidebar.items.customer_listing',
    },
  ]);
});
</script>
